
import Svc from '../service/api'

// =============登录模块======================
//  登录
export const login = ({commit},params) => {
    return Svc.login(params)
}
//  退出登录
export const logout = ({commit},params) => {
    return Svc.logout(params)
}
//  更新用户信息
export const updateUserInfo = ({commit},params) => {
    return Svc.updateUserInfo(params)
}
//  添加我的收藏
export const addMyFavoriteItem = ({commit},params) => {
    return Svc.addMyFavoriteItem(params)
}
//  添加我的收藏
export const queryMyFavorites = ({commit},params) => {
  return Svc.queryMyFavorites(params)
}
//  添加我的收藏
export const removeMyFavorite = ({commit},params) => {
  return Svc.removeMyFavorite(params)
}
// =============产品模块==========================
//  查询产品异动
export const getSingularProduct = ({commit}) => {
    return Svc.getSingularProduct()
}
//  更新产品异动
export const getProductRemind = ({ commit },params) => {
    return Svc.getProductRemind(params)
}
//  产品搜索
export const productSearch = ({commit},params) => {
    return Svc.productSearch(params)
}
//  查询产品产业链
export const getProductChain = ({commit},params) => {
    return Svc.getProductChain(params)
}
//  查询产品数据
export const getProductData = ({commit},params) => {
    return Svc.getProductData(params)
}
//  查询产品指标
export const getProductSeries = ({commit},params) => {
    return Svc.getProductSeries(params)
}
//  查询产品指标数据
export const getProductSeriesData = ({commit},params) => {
    return Svc.getProductSeriesData(params)
}
//  查询查询生产公司
export const getCompanysByProduct = ({commit},params) => {
  return Svc.getCompanysByProduct(params)
}
//  增加详情操作记录
export const addHistoryOpeParam = ({commit},params) => {
    return Svc.addHistoryOpeParam(params)
}
//  查询历史操作记录
export const queryHistoryOpeParam = ({commit},params) => {
    return Svc.queryHistoryOpeParam(params)
}

//  查询行业贺新年产业链
export const getCoreProductChain = ({commit},params) => {
  return Svc.getCoreProductChain(params)
}

//  查询产品异动
export const getCoreNameInfo = ({commit}) => {
  return Svc.getCoreNameInfo()
}

// =====================公司模块==================================
// 公司搜索
export const companySearch = ({commit},params) => {
    return Svc.companySearch(params)
}
//  查询公司展望
export const getCompanyProspect = ({commit}) => {
    return Svc.getCompanyProspect()
}
//  查询公司核心驱动
export const getCompanyCoreDrive = ({commit},params) => {
    return Svc.getCompanyCoreDrive(params)
}
// 查询公司核心驱动指标数据
export const getCompanyCoreDriveSeriesData = ({commit},params) => {
    return Svc.getCompanyCoreDriveSeriesData(params)
}
//  查询公司核心产品
export const getCompanyCoreProduct = ({commit},params) => {
    return Svc.getCompanyCoreProduct(params)
}
//  查询公司核心产品指标数据
export const getCompanyCoreProductSeriesData = ({commit},params) => {
    return Svc.getCompanyCoreProductSeriesData(params)
}
//  查询公司核心概念
export const getCompanyCoreConcept = ({commit},params) => {
    return Svc.getCompanyCoreConcept(params)
}
//  查询相关公司
export const getRelatedCompany = ({commit},params) => {
    return Svc.getRelatedCompany(params)
}
//  查询概念相关公司
export const getRelatedCompanyFromConcept = ({commit},params) => {
    return Svc.getRelatedCompanyFromConcept(params)
}
//  查询概念相关公司
export const getCompanyCoreProductIssueData = ({commit},params) => {
  return Svc.getCompanyCoreProductIssueData(params)
}

//  修改store中的数据
export const userInfo = ({commit},userInfo) => {
    commit("USERINFO",userInfo);
}
export const setLoginState = ({commit},isLogin) => {
  commit("ISLOGIN",isLogin);
}
export const indexSearchInfo = ({commit},indexSearchInfo) => {
    commit("INDEXSEARCHINFO",indexSearchInfo);
}
export const proPageSearchParams = ({commit},proPageSearchParams) => {
    commit("PROPAGESEARCHPARAMS",proPageSearchParams);
}
export const Authorization = ({commit},Authorization) => {
    commit("AUTHORIZATION",Authorization);
}
export const productShowInfo = ({commit},productShowInfo) => {
    commit("PRODUCTSHOWINFO",productShowInfo);
}
export const productRouterInfo = ({commit},productRouterInfo) => {
    commit("PRODUCTROUTERINFO",productRouterInfo);
}
export const conceptList = ({commit},conceptList) => {
    commit("CONCEPTLIST",conceptList);
}
export const setCoreName = ({commit},coreName) => {
  commit("CORENAME",coreName);
}



// WEBPACK FOOTER //
// ./src/store/actions.js